const PageMaterial = () => import('@/modules/xmsb/material/PageMaterial')

export default [
  {

    path: '/material',
    name: 'material',
    component: PageMaterial,
    meta: {
      title: '材料清单',
      isBlack: true
    },
  },
]
